import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'glamorous';
import Chip from 'react-toolbox/lib/chip';
import Dialog from 'react-toolbox/lib/dialog';
import { getDisplayPrice } from '../../../../../../../common/utils/format-currency';
import {
  genericObjectSort,
  SortProperty,
} from '../../../../../../../common/utils/object-sort';
import MembersOnly from '../../MembersOnly';
import { PriceList, PriceChip, PriceListContainer } from './styles';
import { FormSubHeader } from '../styles';

class PriceChipList extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object,
    priceSelectionHandler: PropTypes.func,
    event: PropTypes.shape({
      color: PropTypes.string,
      pricing: PropTypes.arrayOf(
        PropTypes.shape({
          numberOfSeats: PropTypes.number,
          isGuestPrice: PropTypes.bool,
          isMemberPrice: PropTypes.bool,
          isCurrentlyAvailable: PropTypes.bool,
          price: PropTypes.number,
          tableName: PropTypes.string,
          name: PropTypes.string,
        })
      ),
      numberOfSeatsAvailable: PropTypes.number,
    }),
  };
  state = {
    activeChip: {
      key: '',
      isTable: false,
    },
    saveChip: null,
    isModalActive: {
      table: false,
      member: false,
    },
  };

  componentWillMount() {
    // if there is only one price available, pre-select it
    this.autoSelectPrice(this.props.userPrices);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userPrices !== this.props.userPrices) {
      this.autoSelectPrice(nextProps.userPrices);
    }
  }

  toggleModal = name => () => {
    this.setState(prevState => ({
      isModalActive: {
        ...prevState.isModalActive,
        [name]: !prevState.isModalActive[name],
      },
    }));
  };

  getGuestPrice = price => {
    // get matching guest price if the price is not for a table
    if (!price.isTable) {
      const { event: { pricing = [] } = {} } = this.props;
      const guestPrices = pricing.filter(
        price => price.isCurrentlyAvailable && price.isGuestPrice
      );

      return guestPrices.find(guestPrice => {
        return price.isMemberPrice === guestPrice.isMemberPrice && guestPrice.isGuestPrice;
      });
    }
    return null;
  };

  handleConfirm = didConfirm => {
    return () => {
      this.setState(prevState => {
        if (!didConfirm) {
          // close modal
          return {
            isModalActive: {
              ...prevState.isModalActive,
              table: false,
            },
          };
        }
        // move saveChip to active
        const { saveChip } = prevState;
        const price = this.props.userPrices.find(
          price => price.key === saveChip.key
        );
        this.props.priceSelectionHandler(price, this.getGuestPrice(price));
        return Object.assign({}, prevState, {
          activeChip: saveChip,
          isModalActive: {
            ...prevState.isModalActive,
            table: false,
          },
        });
      });
    };
  };

  selectPriceChip = (price, prevState) => {
    // do nothing on re-selection of currently selected price
    if (price.Key === prevState.activeChip.key) {
      return prevState;
    }
    if (prevState.activeChip.isTable) {
      // temporarily stash clicked chip in case of confirm
      return Object.assign({}, prevState, {
        saveChip: { key: price.key, isTable: price.isTable },
        isModalActive: {
          ...prevState.isModalActive,
          table: true,
        },
      });
    }

    this.props.priceSelectionHandler(price, this.getGuestPrice(price));
    return Object.assign({}, prevState, {
      activeChip: {
        key: price.key,
        isTable: price.isTable,
      },
    });
  };

  autoSelectPrice = prices => {
    if (prices.length === 1) {
      this.setState(prevState => this.selectPriceChip(prices[0], prevState));
    }
  };

  handleChipClick = price => () =>
    this.setState(prevState => this.selectPriceChip(price, prevState));

  renderPriceList = (prices, header) => {
    const { activeChip } = this.state;
    const {isUserMember} = this.props;
    return prices.length ? (
      <PriceList>
        <h4
          style={{
            backgroundColor: '#ffffff !important',
            width: '100%',
            fontWeight: 'normal',
            marginBottom: '8px',
            marginTop: '12px',
            fontSize: '1.5rem',
          }}
        >
          {header}
        </h4>
        {prices.map(price => (
          <PriceChip
            key={price.key}
            active={price.key === activeChip.key}
            onClick={
              price.isMemberPrice && !isUserMember
                ? () =>
                    this.setState(prevState => ({
                      isModalActive: {
                        ...prevState.isModalActive,
                        member: true,
                      },
                    }))
                : this.handleChipClick(price)
            }
          >
            <Chip
              style={{
                color: '#ffffff',
                overflow: 'initial',
                marginRight: '8px',
                border: '1px solid transparent',
                backgroundColor: price.key === activeChip.key ? '#00AD50' : '#9e9e9e',
                verticalAlign: !!document.documentMode ? 'middle' : 'baseline',
              }}
            >
              {getDisplayPrice(price.price)}
            </Chip>
            <span>
              {price.isTable
                ? `${price.tableName} - ${price.name}`
                : price.name}
            </span>
          </PriceChip>
        ))}
      </PriceList>
    ) : null;
  };

  render() {
    const { event: { isFree } = {}, userPrices } = this.props;

    if (isFree) {
      return null;
    }

    const sortProps = [new SortProperty('Name')];
    const individualPrices = userPrices.filter(price => !price.isTable);
    const tablePrices = userPrices.filter(price => price.isTable);
    const actions = [
      { label: 'cancel', onClick: this.handleConfirm(false) },
      { label: 'confirm', onClick: this.handleConfirm(true) },
    ];

    return userPrices && userPrices.length ? (
      <div>
        <FormSubHeader>Select Registration Type</FormSubHeader>
        <PriceListContainer>
          {this.renderPriceList(
            individualPrices.sort(genericObjectSort(sortProps)),
            'Individual'
          )}
          {this.renderPriceList(
            tablePrices.sort(genericObjectSort(sortProps)),
            'Table'
          )}
        </PriceListContainer>

        <Dialog
          actions={actions}
          active={this.state.isModalActive.table}
          title={'Are you sure?'}
          style={{ fontSize: '1.4rem' }}
        >
          <p>Your table entries will be lost. Do you want to continue?</p>
        </Dialog>
        <Dialog
          active={this.state.isModalActive.member}
          actions={[
            {
              label: 'close',
              onClick: this.toggleModal('member'),
            },
          ]}
          onEscKeyDown={this.toggleModal('member')}
          onOverlayClick={this.toggleModal('member')}
        >
          <MembersOnly
            title="Member Only"
            text={
              'This option is for active NFIB members. If you are an NFIB member ' +
              'and cannot select member options, please call 1-800-NFIB-NOW or contact the event ' +
              'manager at the number in the event description.'
            }
            organization={this.props.organization}
            currentUser={this.props.currentUser}
            event={this.props.event}
            closeDialog={this.toggleModal('member')}
          />
        </Dialog>
      </div>
    ) : null;
  }
}

export default withTheme(PriceChipList);



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/PriceChipList/index.js